import { eventEmitter, EventType, setupEventEmitter } from '@/services/events';
import { createDecorator } from 'vue-class-component';
/**
 * Decorator for events
 * @param path the path or the expression to observe
 * @param watchOptions
 */
export function ListenEvent(path: EventType) {
    return createDecorator((componentOptions, propertyKey) => {
        const originalMethod = componentOptions.methods[propertyKey];
        const orginalMounted = componentOptions.mounted ?? (() => { });
        const orginalBeforeUnmount = componentOptions.beforeUnmount ?? (() => { });

        // const method = (...args) => originalMethod.apply(options, args)

        // Kept per instance: during a route transition the incoming component mounts
        // before the outgoing one unmounts, so a shared reference would be clobbered.
        const handlers = new WeakMap<object, (...args: any[]) => void>();

        componentOptions.mounted = function wrapper() {
            if (!this) {
                return;
            }
            const handler = (...args) => {
                originalMethod.apply(this, args)
            };
            handlers.set(this, handler);
            orginalMounted.apply(this);
            if (!eventEmitter.on) {
                setupEventEmitter();
            }
            eventEmitter.on(path, handler);
        }

        componentOptions.beforeUnmount = function wrapper() {
            orginalBeforeUnmount.apply(this);
            const handler = handlers.get(this);
            if (handler && eventEmitter.off) {
                eventEmitter.off(path, handler);
            }
            handlers.delete(this);
        }
    });
}
